import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const IndustryPlatformPage = lazy(() => import('../pages/industry-platform/page'));
const HealthPlatformPage = lazy(() => import('../pages/health-platform/page'));
const EnterprisePlatformPage = lazy(() => import('../pages/enterprise-platform/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/industry-platform',
    element: <IndustryPlatformPage />,
  },
  {
    path: '/health-platform',
    element: <HealthPlatformPage />,
  },
  {
    path: '/enterprise-platform',
    element: <EnterprisePlatformPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;